{
  "name": "doenkids-admin-portal",
  "version": "0.87.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --host 0.0.0.0",
    "start:beinspired": "ng serve --host 0.0.0.0 --configuration beinspired",
    "start:ovivio-activities": "ng serve --host 0.0.0.0 --configuration ovivio-activities",
    "start-hmr": "ng serve --configuration hmr",
    "build": "npm run generate-supported-browsers && ng build",
    "build:prod": "npm run generate-supported-browsers && node --max_old_space_size=8000 ./node_modules/@angular/cli/bin/ng build --configuration production",
    "build:prod:beinspired": "npm run generate-supported-browsers && npm run generate-beinspired-translations && node --max_old_space_size=8000 ./node_modules/@angular/cli/bin/ng build --configuration beinspired_prod",
    "build:prod:ovivio-activities": "npm run generate-supported-browsers && node --max_old_space_size=8000 ./node_modules/@angular/cli/bin/ng build --configuration ovivio_activities_prod",
    "buildinfo": "node ./scripts/writeBuildJson.js",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "tag:deploy:prod": "TAG=deploy/prod/$( date -u +\"%Y-%m-%dT%H%M%SZ\" ); git checkout master && git pull && git tag -a $TAG -m 'Production deploy tag' && ( echo; echo \"Tag: '$TAG' created on the latest commit on MASTER\"; echo; echo ' >>> YOU STILL NEED TO PUSH THIS TAG: git push --tags <<<' )",
    "sentry-release": "./scripts/sentry-release.sh",
    "i18n:extract": "node ./scripts/extractTranslations.js",
    "i18n:check": "node ./scripts/checkTranslations.js",
    "bundle-report": "webpack-bundle-analyzer dist/stats.json",
    "generate-supported-browsers": "echo \"export default $(browserslist-useragent-regexp --allowHigherVersions --ignorePatch --ignoreMinor);\" > ./src/components/browser-not-supported/supportedBrowsers.ts",
    "generate-beinspired-translations": "node ./scripts/generateTranslationsForConfig.js --client='BE Inspired'"
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/core": "^20.3.0",
    "@angular-ex/uploader": "^16.0.0",
    "@angular/animations": "^20.3.0",
    "@angular/cdk": "^20.2.2",
    "@angular/common": "^20.3.0",
    "@angular/compiler": "^20.3.0",
    "@angular/core": "^20.3.0",
    "@angular/forms": "^20.3.0",
    "@angular/material": "^20.2.2",
    "@angular/platform-browser": "^20.3.0",
    "@angular/platform-browser-dynamic": "^20.3.0",
    "@angular/router": "^20.3.0",
    "@auth0/auth0-angular": "^2.2.3",
    "@biesbjerg/ngx-translate-extract-marker": "^1.0.0",
    "@datorama/akita": "^8.0.1",
    "@fullcalendar/core": "^6.1.8",
    "@fullcalendar/daygrid": "^6.1.8",
    "@fullcalendar/interaction": "^6.1.8",
    "@fullcalendar/list": "^6.1.8",
    "@fullcalendar/timegrid": "^6.1.8",
    "@fullcalendar/web-component": "^6.1.8",
    "@messageformat/core": "^3.2.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@sentry/browser": "^7.53.0",
    "@sentry/cli": "^2.18.1",
    "@sentry/integrations": "^7.53.0",
    "@zip.js/zip.js": "^2.7.14",
    "angular-google-tag-manager": "^1.8.0",
    "apexcharts": "^3.40.0",
    "browserslist": "^4.22.2",
    "browserslist-useragent-regexp": "^4.1.1",
    "core-js": "^3.30.2",
    "countup.js": "^2.6.2",
    "dayjs": "^1.11.7",
    "deepmerge-ts": "^5.1.0",
    "file-saver": "^2.0.5",
    "flag-icons": "^6.6.6",
    "fullcalendar": "^6.1.8",
    "husky": "^8.0.3",
    "lodash": "^4.17.20",
    "masonry-layout": "^4.2.2",
    "ng-apexcharts": "^1.10.0",
    "ngx-chips": "^3.0.0",
    "ngx-color-picker": "^14.0.0",
    "ngx-extended-pdf-viewer": "^24.3.1-alpha.1",
    "ngx-pagination": "^6.0.3",
    "ngx-quill": "^22.0.0",
    "ngx-translate-messageformat-compiler": "^6.2.0",
    "ngx-translate-multi-http-loader": "^9.3.2",
    "parchment": "^2.0.1",
    "pdfjs": "^2.5.0",
    "quill": "^1.3.7",
    "rxjs": "^7.8.1",
    "swiper": "^9.3.2",
    "tslib": "^2.0.0",
    "uuid": "^8.3.2",
    "viewerjs": "^1.11.3",
    "web-component-essentials": "0.0.4",
    "web-streams-polyfill": "^3.2.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.0",
    "@angular/cli": "^20.3.0",
    "@angular/compiler-cli": "^20.3.0",
    "@angular/language-service": "^20.3.0",
    "@angularclass/hmr": "^3.0.0",
    "@bartholomej/ngx-translate-extract": "^8.0.2",
    "@types/d3-scale": "^4.0.3",
    "@types/d3-shape": "^3.1.1",
    "@types/file-saver": "^2.0.5",
    "@types/jasmine": "^5.1.15",
    "@types/lodash": "^4.14.194",
    "@types/moment-timezone": "^0.5.30",
    "@types/node": "^14.17.33",
    "@typescript-eslint/eslint-plugin": "^5.59.7",
    "@typescript-eslint/parser": "^5.59.7",
    "codelyzer": "^6.0.1",
    "eslint": "^8.41.0",
    "eslint-config-airbnb": "^19.0.4",
    "eslint-config-airbnb-typescript": "^17.0.0",
    "eslint-import-resolver-typescript": "^3.5.5",
    "eslint-plugin-import": "^2.27.5",
    "eslint-plugin-jsx-a11y": "^6.7.1",
    "jasmine-core": "^5.10.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-coverage-istanbul-reporter": "^3.0.3",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "minimist": "^1.2.8",
    "prettier": "^2.8.8",
    "ts-node": "^10.9.1",
    "typescript": "5.8"
  },
  "husky": {
    "hooks": {
      "pre-push": "tsc --noEmit"
    }
  }
}
